export default ({ columnWidth }) => {
	return {
		columnWidth,
	};
};
